import * as React from "react";
import { SvgIcon, SvgIconProps } from "../widget";

export default (props: SvgIconProps) => {
    return <SvgIcon {...props}>
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
}